import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'narwhalia-population',
  templateUrl: './population.component.html',
  styleUrls: ['./population.component.scss']
})
export class PopulationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
